import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";

import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import moveInOutStore from "../../stores/MoveInOutStore";
import ButtonPrimary from "../../components/button.primary/button.primary.component";
import FileUpload from "./FileUpload";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import { NotifyError } from "../../utils/ShowError";
import { set } from "mobx";



interface MoveoutDisputeProps {}

const MoveoutDispute: React.FC<MoveoutDisputeProps> = () => {
  const [value, setValue] = useState(0);
  const [parcelNumber, setParcelNumber] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [disputeDetails, setDisputeDetails] = useState<any[]>([]);
  const [selectedDispute, setSelectedDispute] = useState<any>(null);
  const navigate = useNavigate();
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handlerSearchParcelNumber = async () => {
    const result = await moveInOutStore.getMoveOutDisputeDetails({
      errorId: "DisputeError",
      data: { parcelNumber, unitNumber },
    });
    console.log(result);
    if (result?.length > 0) {
      setDisputeDetails(result);
    } else {
      setDisputeDetails([]);
      NotifyError("No premise found for the input Parcel ID");
    }
  };

  const handleDisputeSelect = (detail: any) => {
    setSelectedDispute(detail);
  };

  const handleNext = async () => {
    if (selectedDispute) {
      const payload = {
        personId: User?.info?.personId,
        premiseId: selectedDispute?.premiseId,
      }
      const res = await moveInOutStore.checkDisputeExist({
        errorId: "ValidateDisputeError",
        data: payload,
      });
      
      if (!res) {
        setValue(1);
      }
      else{
        NotifyError("You already have an existing dispute. Please contact support for further assistance.");
      }
    } else {
      NotifyError("Please select a dispute to continue.");
    }
  };
  const handleFileUpload = async (files: File[],additionFileCount : number , tenanacyContractFileCount : number) => {
    console.log("Files to upload:", files);
    console.log("Addition File Count:", additionFileCount);
    console.log("Tenancy Contract File Count:", tenanacyContractFileCount);
    const multiFileUpload = Object.values(files);
    const data = {
      additionFileCount:additionFileCount,
      defaultAccountId : selectedDispute?.defaultAccountId,
      ownerName: selectedDispute?.ownerPersonName,
      ownerPersonId : selectedDispute?.ownerPersonId,
      parcelId: parcelNumber,
      premiseDetails:selectedDispute?.premiseDetails,
      premiseId:selectedDispute?.premiseId,
      // premiseUsage:selectedDispute?.premiseUsage,
      tenanacyContractFileCount:tenanacyContractFileCount,
      tenantPersonId : selectedDispute?.tenantPersonId,
      unitNumber:unitNumber,
      uosAccountId: selectedDispute?.uosAccountId,
   }
    const payload = {
      data: data,
      multiFileUpload: multiFileUpload,
      isFileUploadValid: true,
      invalidFileNames: [],
    }
    console.log("Payload for file upload:", payload);
    const res = await moveInOutStore.applyMoveOutDispute({
      errorId: "ApplyDisputeError",
      data: payload,
    });
    if (res) {
      setValue(2);
    }
  }

  return (
    <>
      <MoveInHeader
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : "#fff",
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : ColorAss === "#101E8E"
            ? "#62aa51"
            : General?.ColorAss,
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "rgba(98, 170, 81, 1)",
              }}
              onClick={() =>
                navigate("/dashboard", { state: { fromRefund: true } })
              }
            >
              {General?.codeLabels["cm_back"]?.label
                ? General?.codeLabels["cm_back"]?.label
                : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && (
              <ButtonSecondary
                style={{
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#fff",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "rgba(98, 170, 81, 1)",
                  width:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "12rem"
                      : "117px",
                  height: "30px",
                  border: "1px solid #FFF",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  zIndex: "0",
                }}
                onClick={() => navigate("/dashboard")}
              >
                {General?.codeLabels["cm_dashboard"]?.label
                  ? General?.codeLabels["cm_dashboard"]?.label
                  : "DASHBOARD"}
              </ButtonSecondary>
            )}
          </MiniNav>
            <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen
              ? `${3.1 * General.accessibility.fontSize}rem`
              : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
            >
            {General?.codeLabels["cm_moveout_dispute"]?.label
              ? General?.codeLabels["cm_moveout_dispute"]?.label
              : "Move-out Dispute"}
            </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          backgroundColor:
            value === 3
              ? "#eeeeee"
              : contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
          width: General?.isLargeScreen ? "" : "100%",
        }}
      >
        <Box
          sx={{
            width: General?.isLargeScreen ? "80%" : "100%",
            marginTop: General?.isLargeScreen ? "40px" : "1rem",
          }}
        >
          {value !== 3 && (
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: General?.isLargeScreen ? "" : "center",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  alignSelf: "flex-end",
                  marginBottom: "0px",
                  zIndex: "0",
                  width: { md: "70%", lg: "100%" },
                }}
                variant="scrollable"
                allowScrollButtonsMobile
              >
                <Tab
                  label={
                    <TabWithCount value={value} count={1}>
                      {General?.isLargeScreen && (
                        <span
                          style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : General?.ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_dispute_case"]?.label
                          ? General?.codeLabels["cm_dispute_case"]?.label
                          : "Dispute Details"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  {...a11yProps(0)}
                  sx={{
                    background: General?.isLargeScreen
                      ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8"
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  // disabled={value == 1 ? false : true}
                  disabled
                />
                <Tab
                  label={
                    <TabWithCount count={2} value={value}>
                      {General?.isLargeScreen && (
                        <span
                          style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : General?.ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_nocmandatoryattachments"]?.label
                          ? General?.codeLabels["cm_nocmandatoryattachments"]?.label
                          : "Required Documents"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  {...a11yProps(1)}
                  sx={{
                    background: General?.isLargeScreen
                      ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8"
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  // disabled={value == 2 ? false : true}
                  disabled
                />
                <Tab
                  label={
                  <TabWithCount count={3} value={value}>
                    {General?.isLargeScreen && (
                    <span
                      style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : General?.ColorAss,
                      }}
                    >
                      Success
                    </span>
                    )}
                  </TabWithCount>
                  }
                  {...a11yProps(2)}
                  sx={{
                  background: General?.isLargeScreen
                    ? contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#e7e9f8"
                    : "",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                  }}
                  // disabled={value == 3 ? false : true}
                  disabled
                />
              </Tabs>
            </Box>
          )}
          <TabPanel value={value} index={0}>
            <div style={{ padding: "20px", background: "#fff" }}>
              {/* <h2 style={{ fontFamily: 'Segoe UI', fontWeight: 'normal' }}>Move-out Dispute Details</h2> */}
              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontFamily: "Segoe UI",
                  }}
                >
                  {General?.codeLabels["cm_nocenterparcelnumber"]?.label}
                </label>
                <input
                  type="number"
                  style={{
                    width: "50%",
                    padding: "8px",
                    boxSizing: "border-box",
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                    // height: "46px",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#edf4f6",
                  }}
                  onChange={(e) => setParcelNumber(e.target.value)}
                />
              </div>
              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontFamily: "Segoe UI",
                  }}
                >
                  {General?.codeLabels["cm_enter_unit_number"]?.label}
                </label>
                <input
                  type="number"
                  style={{
                    width: "50%",
                    padding: "8px",
                    boxSizing: "border-box",
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                    // height: "46px",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#edf4f6",
                  }}
                  onChange={(e) => setUnitNumber(e.target.value)}
                />
              </div>
                <div>
                <ButtonPrimary
                  onClick={() => handlerSearchParcelNumber()}
                  disabled={!parcelNumber || !unitNumber}
                  label={General?.codeLabels["cm_search"]?.label ? General?.codeLabels["cm_search"]?.label : "Search"}
                  styles={{ color: "#fff" }}
                />
                </div>
              {disputeDetails.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                    <h3 style={{ fontFamily: "Segoe UI", fontWeight: "normal", marginTop:"2px" , marginBottom: "10px" }}> 
                    {General?.codeLabels["cm_propertydet"]?.label ? General?.codeLabels["cm_propertydet"]?.label : "Property Details"}
                    </h3>
                  {disputeDetails.map((detail, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "15px",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        background: "#f9f9f9",
                        width:"80%"
                      }}
                    >
                      <input
                        type="radio"
                        name="dispute"
                        id={`dispute-${index}`}
                        checked={
                          selectedDispute?.premiseId === detail.premiseId
                        }
                        onChange={() => handleDisputeSelect(detail)}
                      />
                      <label
                        htmlFor={`dispute-${index}`}
                        style={{ marginLeft: "10px" }}
                      >
                        <p style={{ margin: "0 0 10px 0", display: "inline" }}>
                            <strong>{General?.codeLabels["cm_dpremiseusage"]?.label ? General?.codeLabels["cm_dpremiseusage"]?.label : "Premise Usage"}:</strong> {detail.premiseUsage}
                        </p>
                        <br />
                        <p style={{ margin: "0", display: "inline" }}>
                            <strong>{General?.codeLabels["cm_premisedetails"]?.label ? General?.codeLabels["cm_premisedetails"]?.label : "Premise Details"}:</strong>{" "}
                          {detail.premiseDetails}
                        </p>
                      </label>
                    </div>
                  ))}
                  <ButtonPrimary
                    onClick={handleNext}
                    styles={{ marginTop: "20px",color: "#fff",  }}
                    label={General?.codeLabels["cm_btncontinue"]?.label !== undefined
                    ? General?.codeLabels["cm_btncontinue"]?.label
                    : "Continue"}
                  />
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            {selectedDispute && (
              <FileUpload onSubmit={async (files,additionFileCount,tenantAttachmentCount) => {handleFileUpload(files,additionFileCount,tenantAttachmentCount)}} submitLoader={false} Previous={() => setValue(value - 1)}/>
            )}
          </TabPanel>
            <TabPanel value={value} index={2}>
            <Thankyou
              title={
              General?.codeLabels["cm_dispute_request"]?.label?.replace(
                "{0}",
                moveInOutStore?.moveoutDisputeDetails.referenceId
              ) || "Move-out Dispute Submitted Successfully"
              }
              referenceId={moveInOutStore?.moveoutDisputeDetails.referenceId}
              serviceID={1}
              // downloadLoader={downloadLoader}
              // downloadBillPDF={downloadBillPDF}
            />
            </TabPanel>
        </Box>
      </ComplaintContainer>
    </>
  );
};

export default MoveoutDispute;
